import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { Service } from "../../../../../models/service";
import { Bot } from "../../../../../models/bot";
import { ServiceCategory } from "../../../../../models/service-category";
import { DomainControllerService } from "../../../../../services/service-controller/domain-controller.service";
import { ServiceControllerService } from "../../../../../services/service-controller/service-controller.service";
import { AttributesControllerService } from "../../../../../services/attributes-controller/attributes-controller.service";
import { ServiceCategoryControllerService } from "../../../../../services/service-categories-controller/service-category-controller.service";
import { ServiceGroupControllerService } from "src/app/services/service-group-controller/service-group-controller.service";
import { environment } from "../../../../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { TranslatedBaseError } from "../../../../pages/TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import { ServiceAttribute } from "../../../../../models/service-attribute";
import { ServiceGroup } from "src/app/models/service-group";
import { map } from "rxjs/operators";

@Component({
  selector: "service-settings-options",
  templateUrl: "./service-settings-options.component.html",
  providers: [ServiceControllerService, DomainControllerService, ToastrService],
})
export class ServiceSettingsOptionsComponent extends TranslatedBaseError implements OnInit {

  @Input() public service: Service;
  @Input() public services: Service[] = [];
  @Input() public disableAutoSave: boolean = false;
  public domains: string[] = [];
  public allCategories: ServiceCategory[] = [];
  public serviceCategories: ServiceCategory[] = [];

  public isLoading: boolean = false;
  public attributes: any[] = [];
  public selectedAttributes: any[] = [];
  public groups: ServiceGroup[] = [];

  public readonly publishing: string = "Publishing";
  public readonly categories: string = "Categories";
  public initialValue: string = "";
  public logoUrl: string;
  private restheartUrl: string = environment.RESTHEART_URL;
  public baseUrl: string = environment.BASE_URL;

  public isDrawerClosed: boolean = true;
  public tempGroup: ServiceGroup = new ServiceGroup();

  @Output() public saveEmitter = new EventEmitter();

  constructor(
    private domainControllerService: DomainControllerService,
    private serviceControllerService: ServiceControllerService,
    private attributesControllerService: AttributesControllerService,
    private serviceCategoryControllerService: ServiceCategoryControllerService,
    public serviceGroupControllerService: ServiceGroupControllerService,
    public toastr: ToastrService,
    public translateService: TranslateService,
  ) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.loadAttributes();
    this.loadcategories();
    this.loadGroups();
    if (this.service?.id) {
      this.updateLogoUrl();
      this.loadServiceCategories();
    }
    if (!this.services?.length) {
      this.serviceControllerService.getServicesList().subscribe((services) => {
        this.services = services;
      });
    }
  }

  public loadGroups() {
    this.groups = [];
    this.serviceGroupControllerService.getAllServiceGroups().subscribe(
        (data) => {
            this.groups = data.sort((a, b) => {
                return a.sortOrder - b.sortOrder;
            });
        },
        (error) => this.showErrorMessage(error),
    );
  }

  public editGroup() {
    this.isDrawerClosed = false;
    this.tempGroup = new ServiceGroup();
    this.tempGroup.sortOrder = this.groups.length + 1;
}

public saveGroup(e) {
  if (e) {
    this.serviceGroupControllerService.createGroup(this.tempGroup).subscribe(
      (data) => {
        this.responseSuccessful("Group created");
        this.closeDrawer();
        this.loadGroups();
        if (data) {
          this.updateServiceGroup(data);
        }
      },
      (error) => this.showErrorMessage(error),
    );
  }
}

public closeDrawer() {
  this.tempGroup = new ServiceGroup();
  this.isDrawerClosed = true;
}

  public updateServiceGroup(e) {
    this.service.serviceGroup = e;
    this.saveService();
  }

  public loadAttributes() {
    this.attributesControllerService.getAttributes().subscribe(
      (data) => {
        if (data && data.length > 0) {
          this.attributes = [];
          this.selectedAttributes = [];
          data.forEach((item) => {
            const attribute = this.service?.serviceAttributes?.find((it) => it.attribute === item);
            this.attributes.push({ id: item, text: item });
            if (attribute) {
              this.selectedAttributes.push(item);
            }
          });
        }
      },
    );
  }

  public loadServiceCategories() {
    this.serviceCategoryControllerService.getServiceCategories(this.service?.id).subscribe(
      (serviceCategories) => {
        this.serviceCategories = serviceCategories.sort((a, b) => {
          return Number(a.sortOrder) - Number(b.sortOrder);
        });
    });
  }

  public loadcategories() {
    this.serviceCategoryControllerService.getAllServiceCategories().subscribe(
      (allCategories) => {
        this.allCategories = allCategories.sort((a, b) => {
          return Number(a.sortOrder) - Number(b.sortOrder);
        });
      },
    );
  }

  public autoSave(block: string) {
    switch (block) {
      case "Guide":
      case "Pages":
      case "Publishing":
      case "Settings":
        this.saveServiceAttributes();
        break;
      case "Categories":
        this.saveServiceCategories();
        break;
      case "Contact":
        this.saveService();
        break;
      default:
        break;
    }
  }

  public saveService() {
    if (this.service && this.service.serviceJsonProperties && this.service.serviceJsonProperties.domain === "null") {
      this.service.serviceJsonProperties.domain = null;
    }
    if (!this.disableAutoSave) {
      this.saveEmitter.emit(this.service);
    }
  }

  public saveServiceAttributes() {
    // first remove all not existing service attributes
    this.service.serviceAttributes = this.service.serviceAttributes
        .filter((att) => this.selectedAttributes.indexOf(att.attribute) > -1);
    // add all new service attributes
    this.selectedAttributes.filter((attr) => this.service.serviceAttributes.map((a) => a.attribute).indexOf(attr) === -1)
      .forEach((item) => {
        const attr = new ServiceAttribute();
        attr.attribute = item;
        this.service.serviceAttributes.push(attr);
      });
    this.saveService();
  }

  public saveServiceCategories() {
    this.service.serviceCategories = this.serviceCategories;
    this.saveService();
  }

  public onChange(event, block: string) {
    this.autoSave(block);
  }

  public selected(value: any): void {
    if (this.selectedAttributes === undefined) {
      this.selectedAttributes = [];
    }
    this.onChange(value, this.publishing);
  }

  public removed(value: any): void {
    this.onChange(value, this.publishing);
  }

  public startEdit(event) {
    this.initialValue = event.target.value;
  }

  public submitEditOnFocus(event, block: string) {
    if (block === this.categories) {
      this.addNewCategory(this.initialValue);
    } else {
      this.autoSave(block);
    }
  }

  public addNewCategory(newCategory: string) {
    const serviceCategory: ServiceCategory = new ServiceCategory();
    serviceCategory.category = newCategory;
    this.serviceCategoryControllerService.createCategory(serviceCategory).subscribe(
      (data) => {
        this.responseSuccessful("Category created!");
        this.initialValue = "";
        this.loadcategories();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public updatecatName(e, cat) {
    if (e) {
      cat.category = e;
      this.serviceCategoryControllerService.updateCategory(cat).subscribe(
        (data) => {
          this.responseSuccessful("Category updated!");
          this.loadcategories();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public selectedCategory(value: any): void {
    if (this.serviceCategories === undefined) {
      this.serviceCategories = [];
    }
    const attribute = this.serviceCategories.find((it) => it.category === value.category);
    if (attribute) {
      this.serviceCategories.splice(this.serviceCategories.indexOf(attribute), 1);
    } else {
      this.serviceCategories.push(value);
    }
    this.autoSave(this.categories);
  }

  public removeCatecory(cat: ServiceCategory) {
    this.serviceCategoryControllerService.deleteCategory(cat.id).subscribe(
      (data) => {
        this.responseSuccessful("Category removed!");
        this.loadcategories();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public dropped(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
    const promises = [];
    this.allCategories.forEach((c, index) => {
      c.sortOrder = index;
      promises.push(
        this.serviceCategoryControllerService.updateCategory(c).pipe(map((data) => {
            return data;
        })).toPromise(),
      );
    });

    Promise.all<any[]>(promises).then((results: any[]) => {
      console.log(results);
      this.responseSuccessful("Categories order updated!");
      this.loadcategories();
    });
    console.log(this.allCategories);
  }

  public deleteLogo(isConfirmed: boolean) {
    if (isConfirmed && this.service.logoFileId) {
      this.isLoading = true;
      this.serviceControllerService.deleteServiceLogo(this.service?.id).subscribe(
        (data) => {
          this.service.logoFileId = undefined;
          this.updateLogoUrl();
        },
        (error) => this.showErrorMessageWithTitle("File delete error!", error),
        () => this.isLoading = false,
      );
    }
  }

  public logoFileIdChanged(logoFileId: any) {
    console.log(logoFileId);
    if (logoFileId ) {
      this.service.logoFileId = logoFileId;
      this.updateLogoUrl();
      this.autoSave(this.publishing);
    }
  }

  public updateLogoUrl() {
    if (this.service && this.service.logoFileId) {
      this.logoUrl = this.restheartUrl + "service/" + this.service.id + ".files/" + this.service.logoFileId + "/binary";
    } else {
      this.logoUrl = undefined;
    }
  }

  public isActivCatecory(cat: ServiceCategory) {
    const attribute = this.serviceCategories.find((it) => it.id === cat.id);
    if (attribute) {
      return true;
    }
    return false;
  }

}
